import i18next from 'i18next';

i18next.addResources('en', 'MaturationInformationModal', {
  caskType: 'Cask Type',
  woodFill: 'WOOD/FILL',
  spiritType: 'Spirit Type',
  vintage: 'Vintage',
  caskNO: 'Cask NO'
});
